__webpack_require__.p = "https://fe.beta.registry.geostudio.app.amazon.dev/";